/**
 * Compact KPI tiles + Daily report shown on the Overview/Today tab of
 * operator (scope="operator") and cashier (scope="cashier") dashboards.
 * Backed by /api/cashier/daily-report which returns store-wide totals when
 * the caller is an operator and sub-group totals when caller is a cashier.
 */
import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const fmt = (n) => `$${(Number(n) || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const DailyReportTiles = ({ extra = null }) => {
    const [data, setData] = useState(null);
    useEffect(() => {
        axios.get(`${API}/cashier/daily-report`, { withCredentials: true })
            .then(({ data }) => setData(data))
            .catch(() => { });
    }, []);
    const t = data?.totals || {};
    const net = (t.loaded || 0) - (t.cashed || 0);

    return (
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3" data-testid="daily-tiles">
            <Tile label="Loaded today" value={fmt(t.loaded || 0)} sub={`${t.load_count || 0} txns`} />
            <Tile label="Cashed today" value={fmt(t.cashed || 0)} sub={`${t.cashout_count || 0} txns`} />
            <Tile label="Net house" value={fmt(net)}
                valueClass={net >= 0 ? 'text-emerald-300' : 'text-rose-300'} />
            <Tile label="Unique players" value={t.unique_players || 0}
                sub={(t.new_players || 0) > 0 ? `+${t.new_players} new today` : null} />
            <Tile label="Pending cashouts" value={t.pending_cashouts || 0}
                valueClass={(t.pending_cashouts || 0) > 0 ? 'text-amber-300' : 'text-zinc-100'} />
            {extra}
        </div>
    );
};

const Tile = ({ label, value, sub, valueClass = 'text-zinc-100' }) => (
    <div className="rounded-md border border-zinc-800 bg-zinc-900/40 px-4 py-3">
        <p className="text-[10px] uppercase tracking-widest text-zinc-500 font-medium">{label}</p>
        <p className={`text-xl font-mono font-semibold ${valueClass} mt-1`}>{value}</p>
        {sub && <p className="text-[10px] text-zinc-500 mt-0.5">{sub}</p>}
    </div>
);

export default DailyReportTiles;
